import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { regExps, OapStandarErrorStateMatcher, errorMessages, OapErrorMessages, CustomValidatorsModule } from 'src/app/modules/custom-validators/custom-validators.module';
import { MessageService } from 'src/app/services/message.service';
import { AlertService } from 'src/app/services/alert.service';
import { GestionnaireUpdate } from 'src/app/models/gestionnaireUpdate';
import { first } from 'rxjs/operators';
import { TypeCompte } from '../../gestionnaire.model';
import { GestionnaireCreate } from 'src/app/models/gestionnaireCreate';
import { ManagerUsersService } from '../../manager-users.service';
import { ManagerUserData, buildManagerUserData } from '../../manager-users.model';

@Component({
  selector: 'oap-detail-user',
  templateUrl: './detail-user.component.html',
  styleUrls: ['./detail-user.component.scss']
})
export class DetailUserComponent implements OnInit {

  adminForm: FormGroup;
  submitted = false;

  typesCompte: TypeCompte[] = [ {code:'T', libelle:'Téléconseiller' }, {code:'G', libelle:'Gestionnaire' } , {code:'V', libelle:'Gestionnaire avancé' }, {code:'A', libelle:'Administrateur' }];

  matcher = new OapStandarErrorStateMatcher();
  errors = errorMessages;
  validation_messages = OapErrorMessages;

  public maskTel = [/\d/,/\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]

  currentMangerUser: ManagerUserData;

  gestionnaireKeyRequested: string;

  editMode = false;

  title: string = 'Ajout utilisateur';

  informations: string;

  constructor(private messageService: MessageService,
    private managerUsersService: ManagerUsersService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private _router: Router,
    private _route: ActivatedRoute) { }

  ngOnInit() {

    this.gestionnaireKeyRequested = this._route.snapshot.paramMap.get('identifiant');
    console.log('gestionnaireKeyRequested: ' + this.gestionnaireKeyRequested);

    this.messageService.sendMessage('detail-user');

    if(this.gestionnaireKeyRequested) {
      this.title = "Modification utilisateur";

      this.managerUsersService.getManagerUser(this.gestionnaireKeyRequested)
      .pipe(first())
      .subscribe(
        data => {
          this.alertService.clear();
          if (data !== null) {
            this.currentMangerUser = buildManagerUserData(data);
            this.setManagerUserForm();
            this.editMode = true;
          }
        },
        error => {
          console.error(error)
          this.alertService.error(error, true);
        });
    }

    this.adminForm = this.formBuilder.group({
      identifiant : ['', [Validators.required, Validators.maxLength(40)]],
      typeCompte: [{value: 'G'}, ],
      lastName : ['', [Validators.required, Validators.maxLength(100)]],
      firstName : ['', [Validators.maxLength(100),
        Validators.pattern(regExps.onlyLettersAccent)]],
      phone : ['', CustomValidatorsModule.maskMinValidator(10)],
      email: ['', [Validators.required,
        Validators.minLength(5),
        Validators.maxLength(256),
        Validators.email]],
      actif: [{value: 'true'}, ]
    });

  }

  private setManagerUserForm() {
    this.adminForm.patchValue(
      {
        identifiant : this.currentMangerUser.identifiant,
        typeCompte: this.currentMangerUser.role,
        lastName : this.currentMangerUser.lastName,
        firstName : this.currentMangerUser.firstName,
        phone : this.currentMangerUser.phoneNumber,
        email : this.currentMangerUser.mail,
        actif: this.currentMangerUser.actif
     });
  }

  onFormSubmit(form: FormGroup) {

    this.submitted = true;

    // stop here if form is invalid
    if (this.adminForm.invalid) {
      return;
    }

    let phone: string = form.controls.phone.value;
    phone = phone ? phone.replace(/\s/g, "") : null;


    if(!this.editMode) {
      const gestionnaireCreated: GestionnaireCreate = {
        identifiant: form.controls.identifiant.value,
        role: form.controls.typeCompte ? form.controls.typeCompte.value : "G",
        nom: form.controls.lastName.value,
        prenom: form.controls.firstName.value,
        email: form.controls.email.value,
        telephone: phone,
        actif: form.controls.actif ? form.controls.actif.value.value : true,
        password: null,
        unCryptedPassword: null,
        sendMail: false,
        expired: true,
      };
      this.createUser(gestionnaireCreated);
    } else {
      const gestionnaireUpdate: GestionnaireUpdate = {
        gestionnaireKey: this.currentMangerUser.managerKey,
        compteKey: this.currentMangerUser.accountKey,
        identifiant: form.controls.identifiant.value,
        role: form.controls.typeCompte.value,
        nom: form.controls.lastName.value,
        prenom: form.controls.firstName.value,
        email: form.controls.email.value,
        telephone: phone,
        actif: form.controls.actif.value,
      };
      this.updateUser(gestionnaireUpdate);
    }
  }

  createUser(gestionnaireCreate: GestionnaireCreate) {
    this.managerUsersService.createManagerUser(gestionnaireCreate)
    .subscribe(
        response => {
          this.alertService.success('Utilisateur crée', true);
          this._router.navigateByUrl('/admin/manage-users');
          },
        error => {
          console.log(error);
          this.alertService.error(error);
        });
  }

  updateUser(gestionnaireUpdate: GestionnaireUpdate) {
    this.managerUsersService.updateManagerUser(gestionnaireUpdate)
    .subscribe(
        response => {
          this.alertService.success('Modifications enregistrées', true);
          this._router.navigateByUrl('/admin/manage-users');
        },
        error => {
          console.log(error);
          this.alertService.error(error);
        });
  }

}
